"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52745],{

/***/ 52745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66026);



var VersionManager = function(param) {
    var children = param.children;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var localStorageVersion = localStorage.getItem('version');
        if (localStorageVersion) {
            if (localStorageVersion !== _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .currentVersion */ .KZ) {
                localStorage.clear();
                localStorage.setItem('version', _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .currentVersion */ .KZ);
            }
        } else {
            if (_utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .currentVersion */ .KZ) {
                localStorage.setItem('version', _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .currentVersion */ .KZ);
            }
        }
    }, [
        _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .currentVersion */ .KZ
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (VersionManager);


/***/ })

}]);